/* Mint-Motion v1: hiệu ứng dùng chung. Thời lượng / easing lấy từ token --dur-* / --ease-*. */
@keyframes in {
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to { opacity: 1; transform: none; }
}
@keyframes stamp {
  0% { opacity: 0; transform: rotate(-14deg) scale(1.7); }
  60% { opacity: 1; transform: rotate(-10deg) scale(0.92); }
  100% { opacity: 1; transform: rotate(-10deg) scale(1); }
}
@keyframes dot {
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-3px); }
}
@keyframes bump {
  0% { transform: scale(1); }
  40% { transform: scale(1.25); }
  100% { transform: scale(1); }
}

/* Trang tải lần lượt: 240 ms, cách nhau 40 ms, khối thứ 7 trở đi cùng nhịp khối 6 */
.reveal { animation: in var(--dur-md) var(--ease-out) both; animation-delay: calc(var(--i, 0) * 40ms); }

/* Dấu đóng: 420 ms spring, nghiêng −10° */
.stamp {
  display: inline-block;
  transform: rotate(-10deg);
  animation: stamp 420ms var(--ease-spring) both;
}
.stampOut { opacity: 0; transition: opacity var(--dur-sm) var(--ease-out); }

.bump { animation: bump var(--dur-sm) var(--ease-spring); }

/* Chat: bong bóng nảy lên 180 ms, ba chấm đang gõ 900 ms */
.bubble { animation: in var(--dur-sm) var(--ease-out) both; }
.dots { display: inline-flex; gap: 4px; }
.dots i { width: 6px; height: 6px; border-radius: 50%; background: var(--lb); animation: dot 900ms infinite; }
.dots i:nth-child(2) { animation-delay: 150ms; }
.dots i:nth-child(3) { animation-delay: 300ms; }

@media (prefers-reduced-motion: reduce) {
  .reveal, .stamp, .bump, .bubble, .dots i { animation: none; }
  .stamp { opacity: 1; }
}
